/**
 * `pickError` copiado (não reexportado) de
 * `@/features/quotes/components/capital-global/steps/utils/step-helpers.util.ts`:
 * aquele módulo importa tipos internos do Capital Global, e cruzar produtos
 * é proibido — a função em si é pequena o bastante para duplicar.
 */
export function pickError(
  meta: { errors: unknown[] },
  submitAttempted: boolean
): string | undefined {
  if (!submitAttempted) return undefined;
  return meta.errors[0] as string | undefined;
}

/** Máximo de dias de vigência aceito pelo backend (`maxValidityDays` em `GET /config`). */
export const RD_MAX_VALIDITY_DAYS = 366;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Interpreta uma string `YYYY-MM-DD` (valor de `<input type="date">`) como
 * meia-noite no fuso horário local — evita o desvio de um dia que
 * `new Date('YYYY-MM-DD')` introduz (esse construtor interpreta a string como
 * UTC, não local).
 */
export function parseDateOnly(value: string): Date {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, (month || 1) - 1, day || 1);
}

/** Meia-noite local de hoje, para comparações de vigência. */
export function startOfToday(): Date {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

/** Diferença em dias inteiros entre duas datas (sem hora). */
export function diffInDays(start: Date, end: Date): number {
  return Math.round((end.getTime() - start.getTime()) / MS_PER_DAY);
}

/**
 * Fim de vigência de uma apólice de um ano: mesmo dia do ano seguinte
 * (17/09/2026 → 17/09/2027). Recebe e devolve `YYYY-MM-DD`; string vazia
 * devolve vazia, para o chamador poder limpar o campo derivado quando o
 * início é apagado. Passa por `parseDateOnly` de propósito — `new Date('YYYY-MM-DD')`
 * interpreta como UTC e desloca um dia em fusos negativos.
 */
export function addOneYearMinusDay(isoDate: string): string {
  if (!isoDate) return '';
  const start = parseDateOnly(isoDate);
  // 29/02 não existe no ano seguinte: `Date` transborda para 01/03 — o
  // comportamento desejado para um bissexto (28/02 do ano anterior →
  // 28/02 do próximo).
  const end = new Date(
    start.getFullYear() + 1,
    start.getMonth(),
    start.getDate()
  );
  const mes = String(end.getMonth() + 1).padStart(2, '0');
  const dia = String(end.getDate()).padStart(2, '0');
  return `${end.getFullYear()}-${mes}-${dia}`;
}
